import { get } from 'lodash';
import parse from 'html-react-parser';
import { getLibrary } from './library';

const defaultLibrary = getLibrary();

export const getText = (lookupPath, replacementMap = null, library = defaultLibrary) => {
  let text;
  if (Array.isArray(lookupPath)) {
    text = lookupPath.reduce((acc, path) => `${acc} ${get(library, path, '')}`, '');
  } else {
    text = get(library, lookupPath, '');
  }

  if (!replacementMap) {
    return text;
  }

  const replaceFunction = (m, p1) => {
    const value = replacementMap[p1];
    if (value?.toString) {
      return value.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    return '';
  };
  const output = text.replace(/%([\w]+)%/g, replaceFunction);
  return output;
};

// the HTML-REACT-PARSER library does not protect against XSS; only use on library strings
export const textToComponent = (lookupPath, replacementMap = null, library = defaultLibrary) => (
  parse(getText(lookupPath, replacementMap, library))
);

export default getText;
